import { createContext } from 'react';
import { UserContextType } from '@/contexts/user/types';

export const UserContext = createContext<UserContextType>(
  {} as UserContextType,
);
UserContext.displayName = 'UserContext';
